const clearValidationMessage = (event) => {
  event.currentTarget.setCustomValidity("");
};

const showEmailValidationMessage = (event) => {
  const input = event.currentTarget;

  if (input.validity.valueMissing) {
    input.setCustomValidity("Please enter your email address.");
  } else {
    input.setCustomValidity("Please enter a valid email address.");
  }
};

const showPhoneValidationMessage = (event) => {
  const input = event.currentTarget;

  if (input.validity.valueMissing) {
    input.setCustomValidity("Please enter your mobile number.");
  } else {
    input.setCustomValidity(
      "Please enter a valid 10-digit Indian mobile number."
    );
  }
};

const sanitizePhoneInput = (event) => {
  const input = event.currentTarget;
  input.value = input.value.replace(/\D/g, "").slice(0, 10);
  input.setCustomValidity("");
};

const getLocalToday = () => {
  const now = new Date();
  const localDate = new Date(now.getTime() - now.getTimezoneOffset() * 60000);
  return localDate.toISOString().split("T")[0];
};

const openDatePicker = (event) => {
  const input = event.currentTarget;

  if (typeof input.showPicker === "function") {
    try {
      input.showPicker();
    } catch (error) {
      // The browser still provides its normal date-input interaction.
    }
  }
};

export const emailValidationProps = {
  type: "email",
  required: true,
  pattern: "[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}",
  title: "Please enter a valid email address.",
  autoComplete: "email",
  onInvalid: showEmailValidationMessage,
  onInput: clearValidationMessage,
};

export const phoneValidationProps = {
  type: "tel",
  required: true,
  pattern: "[6-9][0-9]{9}",
  title: "Please enter a valid 10-digit Indian mobile number.",
  inputMode: "numeric",
  autoComplete: "tel",
  minLength: 10,
  maxLength: 10,
  onInvalid: showPhoneValidationMessage,
  onInput: sanitizePhoneInput,
};

export const dateValidationProps = {
  min: getLocalToday(),
  onClick: openDatePicker,
};

export const getValidationProps = (type) => {
  if (type === "email") return emailValidationProps;
  if (type === "tel") return phoneValidationProps;
  if (type === "date") return dateValidationProps;
  return {};
};
